import React, { useState } from "react";
import AbhaNumberDetails from "../abhanumber-details/abhanumber-details";
import {
  AbhaViaSendAadharOtp,
  AbhaViaSendAbhaOtp,
  AlreadyAbhaNumberSearch,
  EncryptDataABDM,
  SearchUsingAbhaAddress,
  SendAadharOtp,
} from "../../services";
import VerifyNumberAbha from "../abhanumber-details/verify-number-abha";
import VerifyAbhaAddress from "./verify-abhaaddress";
import qrcode from "../../assets/image/qrcode.png";
import { useDispatch, useSelector } from "react-redux";
import { setResentCount } from "../../redux/slices/abhaSlice";
import { toast } from "react-toastify";
import { Eye, EyeOff } from "lucide-react";
import { setGlobalCurrentStep } from "../../redux/slices/abhaSlice";

/* ── Step marker images ── */
import step1Img from "../../assets/image/Group 110901.png";
import step2Img from "../../assets/image/Group 110902.png";
import step3Img from "../../assets/image/Group 110919.png";
import formBgImg from "../../assets/image/Group 2147206200.png";
import about from "../../assets/image/about_nha_pg_logo.png";
import { encryptData } from "../../services/aesUtils";

const STEPS = [
  {
    img: step1Img,
    title: "Verify Aadhaar Details",
    desc: "Enter your Aadhaar number and verify with OTP received on Aadhaar linked mobile number.",
  },
  {
    img: step2Img,
    title: "Link mobile number with ABHA",
    desc: "Enter your mobile number and verify with OTP to link with ABHA Address.",
  },
  {
    img: step3Img,
    title: "Create your ABHA",
    desc: "Create your ABHA Number with a unique ABHA address.",
  },
];

const AlreadyAbhaNumber = () => {
  const [inputType, setInputType] = useState("mobile");
  const [inputValue, setInputValue] = useState("");
  const [abhaNumberDetails, setAbhaNumberDetails] = useState(false);
  const [sendOtpResponse, setsendOtpResponse] = useState(false);
  const [otpType, setOtpType] = useState("");
  const [error, setError] = useState("");
  const [showQrModal, setShowQrModal] = useState(false);
  const [resMessage, setResMessage] = useState("");
  const [showAadhaar, setShowAadhaar] = useState(false);
  const [loading, setLoading] = useState(false);
  const [abhaDetails, setAbhaDetails] = useState({ name: "", number: "", txnId: "" });
  const resendCount = useSelector((state) => state.user.resentCount);
  const dispatch = useDispatch();

  const mobileNumberRegex = /^[0-9]{10}$/;
  const aadhaarNumberRegex = /^[0-9]{12}$/;
  const abhaNumberRegex = /^[0-9]{14}$/;
  const abhaAddressRegex = /^[a-zA-Z0-9._%+-]+@sbx$/;

  function formatNumber(inputValue) {
    let str = String(inputValue);
    return str.replace(/^(\d{2})(\d{4})(\d{4})(\d{4})$/, "$1-$2-$3-$4");
  }

  const processAbhaRequest = async () => {
    let response;

    if (inputType === "mobile") {
      response = await AlreadyAbhaNumberSearch({
        headers: {},
        data: { [inputType]: inputValue, otpType, resent_count: resendCount },
      });
      if (response.success !== true) toast.error(response?.message || "Search failed");
      const abha = response.data?.[0]?.ABHA;
      const txnId = response.data?.[0]?.txnId;
      if (response?.resent_count !== undefined) dispatch(setResentCount(response.resent_count));
      if (abha) {
        setAbhaDetails({ name: abha.name, number: abha.ABHANumber, txnId });
        localStorage.setItem("abhaDetails", JSON.stringify({ abha, inputValue }));
        localStorage.setItem("inputValue", inputValue);
        localStorage.setItem("inputType", "mobile");
        localStorage.setItem("otpType", otpType);
        if (txnId) localStorage.setItem("txnId", txnId);
        setAbhaNumberDetails(true);
      }
    } else if (inputType === "aadhaar") {
      // const encryptedInput = await EncryptDataABDM({ body: inputValue });
      const encryptedAadhar = await encryptData(inputValue);
      const payload = {
        scope: ["abha-login", "aadhaar-verify"],
        loginHint: "aadhaar",
        loginId: encryptedAadhar,
        otpSystem: "aadhaar",
        resent_count: resendCount,
      };
      response = await SendAadharOtp({ headers: {}, data: payload });
      if (response?.resent_count !== undefined) dispatch(setResentCount(response.resent_count));
      if (response.success !== true) {
        let errorMessage = response?.error?.loginId || response?.message;
        if (response.error.loginId) errorMessage = "Aadhaar number not registered";
        if (errorMessage?.includes(":")) {
          toast.error(errorMessage.split(":").pop().trim());
        } else {
          toast.error(errorMessage || "Failed to send OTP");
        }
      }
      if (response.success === true) {
        const txnId = response?.data?.txnId;
        if (txnId) localStorage.setItem("txnId", txnId);
        setResMessage(response?.message);
        setsendOtpResponse(true);
      }
    } else if (inputType === "abha") {
      const formattedValue = formatNumber(inputValue);
      const encryptedInput = await EncryptDataABDM({ body: formattedValue });
      if (otpType === "aadhaar") {
        response = await AbhaViaSendAadharOtp({
          headers: {},
          data: { scope: ["abha-login", "aadhaar-verify"], loginHint: "abha-number", loginId: encryptedInput.data, otpSystem: "aadhaar", resent_count: resendCount },
        });
      } else if (otpType === "abdm") {
        response = await AbhaViaSendAbhaOtp({
          headers: {},
          data: { scope: ["abha-login", "mobile-verify"], loginHint: "abha-number", loginId: encryptedInput.data, otpSystem: "abdm", resent_count: resendCount },
        });
      } else {
        toast.error("Please select an OTP method");
      }
      if (response?.resent_count !== undefined) dispatch(setResentCount(response.resent_count));
      if (response.success !== true) toast.error(response?.message || "Failed to send OTP");
      if (response.success === true) {
        const txnId = response?.data?.txnId;
        if (txnId) localStorage.setItem("txnId", txnId);
        setResMessage(response?.message);
        setsendOtpResponse(true);
      }
    } else if (inputType === "abhaaddress") {
      response = await SearchUsingAbhaAddress({
        headers: {},
        data: { abhaAddress: inputValue, resent_count: resendCount },
      });
      if (response?.resent_count !== undefined) dispatch(setResentCount(response.resent_count));
      if (response.success !== true) toast.error(response?.message || "Failed to send OTP for ABHA Address");
      const abha = response?.data;
      if (abha) {
        setAbhaDetails({ name: abha.fullName, number: abha.healthIdNumber, abhaAddress: abha.healthIdNumber });
        localStorage.setItem("abhaDetails", JSON.stringify({ abha, inputValue }));
      }
      localStorage.setItem("inputType", "abhaaddress");
      localStorage.setItem("otpType", "abdm");
      localStorage.setItem("inputValue", inputValue);
      if (response.success === true) {
        const txnId = response?.data?.txnId;
        if (txnId) localStorage.setItem("txnId", txnId);
        setResMessage(response?.message);
        setsendOtpResponse(true);
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let isValid = false;
    if (inputType === "mobile") {
      isValid = mobileNumberRegex.test(inputValue);
      if (!isValid) return setError("Please enter a valid 10-digit Mobile Number");
    } else if (inputType === "aadhaar") {
      isValid = aadhaarNumberRegex.test(inputValue);
      if (!isValid) return setError("Please enter a valid 12-digit Aadhaar Number");
    } else if (inputType === "abha") {
      const digitsOnly = String(inputValue).replace(/-/g, "");
      isValid = abhaNumberRegex.test(digitsOnly);
      if (!isValid) return setError("Please enter a valid 14-digit ABHA Number");
    } else if (inputType === "abhaaddress") {
      isValid = abhaAddressRegex.test(inputValue);
      if (!isValid) return setError("Please enter a valid ABHA Address");
    }
    if (!isValid) return;
    setError("");
    setLoading(true);
    try {
      await processAbhaRequest();
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const getHeading = () => {
    switch (inputType) {
      case "mobile": return "Enter your Mobile Number linked with ABHA";
      case "aadhaar": return "Enter your Aadhaar Number linked with ABHA";
      case "abha": return "Enter your ABHA Number";
      case "abhaaddress": return "Enter your ABHA Address";
      default: return "";
    }
  };

  const handleBack = () => setAbhaNumberDetails(false);

  const radioOptionStyle = (active) => ({
    display: "inline-flex",
    alignItems: "center",
    gap: "6px",
    padding: "6px 14px",
    borderRadius: "999px",
    border: `1.5px solid ${active ? "#1a7fff" : "#e2e5ec"}`,
    background: active ? "rgba(26,127,255,0.08)" : "#f5f6f8",
    color: active ? "#1a7fff" : "#555",
    fontSize: "0.82rem",
    fontWeight: "600",
    cursor: "pointer",
    transition: "all 0.2s",
    fontFamily: "Manrope, sans-serif",
  });

  const NhaRow = () => (
    <div className="lmop-nha-row">
      <span className="lmop-nha-label">Approved by NHA</span>
      <img src={about} alt="NHA Logo" className="lmop-nha-logo" />
    </div>
  );

  /* ── Sub-step renders (AbhaNumberDetails, VerifyNumberAbha, VerifyAbhaAddress) ──
     Ye components apna col-md-6 khud return karte hain,
     isliye inhe sirf parent ke row mein dalna hai */

  if (inputType === "mobile" && abhaNumberDetails) {
    return (
      <AbhaNumberDetails
        handleBack={handleBack}
        initialResentCount={resendCount}
        setServerResentCount={(count) => dispatch(setResentCount(count))}
        setResMessage={setResMessage}
        resMessage={resMessage}
        autoComplete="off"
      />
    );
  }

  if (inputType === "mobile" && sendOtpResponse) {
    return (
      <VerifyNumberAbha
        handleBack={() => setsendOtpResponse(false)}
        inputType="mobile"
        inputValue={inputValue}
        otpType="abdm"
        initialResentCount={resendCount}
        setServerResentCount={(count) => dispatch(setResentCount(count))}
        setResMessage={setResMessage}
        resMessage={resMessage}
        autoComplete="off"
      />
    );
  }

  if (inputType === "aadhaar" && sendOtpResponse) {
    return (
      <VerifyNumberAbha
        handleBack={() => setsendOtpResponse(false)}
        inputType="aadhaar"
        inputValue={inputValue}
        otpType="aadhaar"
        initialResentCount={resendCount}
        setServerResentCount={(count) => dispatch(setResentCount(count))}
        setResMessage={setResMessage}
        resMessage={resMessage}
        autoComplete="off"
      />
    );
  }

  if (inputType === "abha" && sendOtpResponse) {
    return (
      <VerifyNumberAbha
        handleBack={() => setsendOtpResponse(false)}
        inputType="abha"
        otpType={otpType}
        inputValue={inputValue}
        initialResentCount={resendCount}
        setServerResentCount={(count) => dispatch(setResentCount(count))}
        setResMessage={setResMessage}
        resMessage={resMessage}
        autoComplete="off"
      />
    );
  }

  if (inputType === "abhaaddress" && sendOtpResponse) {
    return (
      <VerifyAbhaAddress
        handleBack={() => setsendOtpResponse(false)}
        inputValue={inputValue}
        otpType={otpType}
        inputType="abha-address"
        autoComplete="off"
        initialResentCount={resendCount}
        setServerResentCount={(count) => dispatch(setResentCount(count))}
        setResMessage={setResMessage}
        resMessage={resMessage}
      />
    );
  }

  /* ── Main form — sirf col-md-6 card return karo ── */
  return (
    <>
      <div className="col-12 col-md-6">
        <div
          className="lmop-card-wrap"
          style={{
            backgroundImage: `url(${formBgImg})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          <div className="lmop-card-inner">
            <h3 className="lmop-card-title" style={{ fontSize: "1.2rem" }}>
              {getHeading()}
            </h3>
            <p className="lmop-card-subtitle">
              Select how you want to find your ABHA
            </p>

            {/* Radio pills */}
            <div style={{ display: "flex", flexWrap: "wrap", gap: "8px", marginBottom: "18px" }}>
              {[
                { value: "mobile",      label: "Mobile" },
                { value: "aadhaar",     label: "Aadhaar" },
                { value: "abha",        label: "ABHA Number" },
                { value: "abhaaddress", label: "ABHA Address" },
              ].map((opt) => (
                <label key={opt.value} style={radioOptionStyle(inputType === opt.value)}>
                  <input
                    type="radio"
                    value={opt.value}
                    autoComplete="off"
                    checked={inputType === opt.value}
                    autoComplete="off"
                    onChange={() => { setInputType(opt.value); setInputValue(""); setError(""); }}
                    style={{ display: "none" }}
                  />
                  {opt.label}
                </label>
              ))}
            </div>

            <form onSubmit={handleSubmit}>
              {/* Input */}
              <div style={{ position: "relative" }}>
                <input
                  className="lmop-mobile-input"
                  type={inputType === "aadhaar" ? (showAadhaar ? "text" : "password") : "text"}
                  autoComplete="off"
                  maxLength={
                    inputType === "mobile" ? 10
                    : inputType === "aadhaar" ? 12
                    : inputType === "abha" ? 14
                    : 50
                  }
                  value={inputValue}
                  onChange={(e) =>
                    setInputValue(
                      inputType === "abha"
                        ? e.target.value.replace(/[^\d]/g, "").slice(0, 14)
                        : e.target.value.trim()
                    )
                  }
                  onKeyDown={(e) => {
                    if ((e.ctrlKey || e.metaKey) && ["a","c","v","x"].includes(e.key.toLowerCase())) return;
                    if (
                      inputType !== "abhaaddress" &&
                      e.key !== "Backspace" &&
                      !(e.key >= "0" && e.key <= "9" && e.key !== " " && e.key !== "." && e.key !== ",")
                    ) {
                      e.preventDefault();
                    }
                  }}
                  placeholder={
                    inputType === "mobile" ? "Please enter Mobile Number"
                    : inputType === "aadhaar" ? "Please enter Aadhaar Number"
                    : inputType === "abha" ? "Please enter ABHA Number"
                    : "Please enter ABHA Address"
                  }
                  id="inputField"
                  required
                  style={{ paddingRight: inputType === "aadhaar" ? "44px" : undefined }}
                />
                {inputType === "aadhaar" && (
                  <span
                    style={{ position: "absolute", right: "14px", top: "50%", transform: "translateY(-50%)", cursor: "pointer" }}
                    onClick={() => setShowAadhaar((prev) => !prev)}
                  >
                    {showAadhaar
                      ? <Eye size={18} style={{ color: "#888" }} />
                      : <EyeOff size={18} style={{ color: "#888" }} />
                    }
                  </span>
                )}
              </div>

              {/* OTP type for ABHA Number */}
              {inputType === "abha" && (
                <div style={{ display: "flex", gap: "16px", margin: "12px 0" }}>
                  {[{ value: "abdm", label: "Mobile OTP" }, { value: "aadhaar", label: "Aadhaar OTP" }].map((opt) => (
                    <label key={opt.value} style={radioOptionStyle(otpType === opt.value)}>
                      <input
                        type="radio"
                        name="otpType"
                        value={opt.value}
                        autoComplete="off"
                        onChange={(e) => setOtpType(e.target.value)}
                        checked={otpType === opt.value}
                        style={{ display: "none" }}
                      />
                      {opt.label}
                    </label>
                  ))}
                </div>
              )}

              {error && <p className="lmop-msg-err">{error}</p>}

              <button
                type="submit"
                className={`lmop-continue-btn ${loading ? "bg-disable" : ""}`}
                disabled={loading}
              >
                {loading ? "Linking..." : "Continue"}
              </button>
            </form>

            {inputType !== "aadhaar" && (
              <p style={{ textAlign: "center", marginTop: "14px", fontSize: "0.85rem", color: "#555" }}>
                Don't have an ABHA?{" "}
                <span
                  style={{ color: "#1a7fff", fontWeight: "600", cursor: "pointer" }}
                  onClick={() => dispatch(setGlobalCurrentStep("SendAdharOTP"))}
                >
                  Create New
                </span>
              </p>
            )}

            <NhaRow />
          </div>
        </div>
      </div>

      {/* QR Modal */}
      {showQrModal && (
        <div className="lmop-modal-overlay" onClick={() => setShowQrModal(false)}>
          <div className="lmop-modal-box" onClick={(e) => e.stopPropagation()}>
            <h5>Scan this QR Code</h5>
            <img src={qrcode} alt="QR Code" />
            <button className="lmop-modal-close" onClick={() => setShowQrModal(false)}>Close</button>
          </div>
        </div>
      )}
    </>
  );
};

export default AlreadyAbhaNumber;